/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SearchLoupeMinusIcon20Regular = forwardRef('SearchLoupeMinusIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M6.25 8.25a.75.75 0 1 0 0 1.5h5.5a.75.75 0 0 0 0-1.5h-5.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.502 9a7.498 7.498 0 1 1 13.303 4.745l3.526 3.526a.75.75 0 0 1-1.06 1.06l-3.526-3.526A7.497 7.497 0 0 1 1.503 9ZM9 3.002a5.998 5.998 0 1 0 0 11.996A5.998 5.998 0 0 0 9 3.002Z" })));
});
